import styled from "styled-components";

const StyledDetaEntryFormDisclaimerModal = styled.div`
  background-color: #fff;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  width: 100%;
  line-height: 1.5;
  box-sizing: border-box;
  max-height: 10vh;
  overflow-y: scroll;
  margin-bottom: 15px;

  p {
    margin-top: 0;
  }

  @media (min-height: 500px) {
    max-height: 15vh;
  }

  @media (min-height: 700px) {
    max-height: 25vh;
  }

  @media (min-height: 900px) {
    max-height: 40vh;
  }

  @media (min-height: 1000px) {
    max-height: 50vh;
  }
`;

export default StyledDetaEntryFormDisclaimerModal;
